module.exports = __webpack_public_path__ + "media/img/eq_true-d4d22b82.png";